// @flow
import React from 'react';
import 'react-mdl/extra/material.js';
import {Textfield} from 'react-mdl';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMEnterpriseResource from 'resources/SMEnterpriseResource.js';
import SMAppHelper from 'components/helpers/SMAppHelper';

type State = {
  errors: Object,
  canRequest: boolean,
};

class SMEnterpriseView extends React.Component {
  state: State;

  constructor() {
    super();

    this.state = {
      errors: {},
      canRequest: true,
    };
  }

  formDidSubmit(e: SyntheticEvent) {
    if (!this.state.canRequest) return;
    this.setState({canRequest: false});
    e.preventDefault();

    const formData = new FormData(this.refs.form);
    SMEnterpriseResource.inquiry(formData, (inquiry, error, xhr) => {
      if (error) {
        this.setState({canRequest: true});
        switch (xhr.status) {
          case 400:
            const errorsArray = xhr.responseJSON.errors;
            let errors = {};
            errorsArray.forEach((error) => {
              errors[error.field] = error.message;
            });
            this.setState({errors: errors});
            break;
          case 500:
            break;
        }
      } else {
        SMAppHelper.redirectTo(Routes.sent_enterprises_path());
      }
    });
  }

  renderFormItemError(name: string) {
    const message = this.state.errors[name];
    if (message) {
      return (
        <p className="signup-box__required"><i className="fa fa-exclamation-circle"></i>{message}</p>
      );
    }
    return null;
  }

  renderEnterpriseInquiryForm() {
    const defaultRows = 6;

    return (
      <div className="container">
        <h2 className="enterprise__contact-title">お問い合わせ</h2>
        <p className="enterprise__contact-text">シェアリング型イベントマーケティングへのお申し込み、資料請求などのお問い合わせは下記フォームよりご連絡ください。</p>
        <div className="signup-box enterprise__contact-box">
          <form ref="form" onSubmit={this.formDidSubmit.bind(this)}>
            <div className="row">
              <div className="col-xs-12">
                <div className="signup-box__wrapper-form">
                  <div className="row signup-box__md-top">
                    <div className="col-sm-12">
                      <Textfield
                        className="w100per"
                        id="enterprise_inquiry_name"
                        name="name"
                        label={I18n.t("service.label_000504")}
                        floatingLabel
                      />
                      {this.renderFormItemError("name")}
                    </div>
                    <div className="col-sm-12">
                      <Textfield
                        className="w100per"
                        id="enterprise_inquiry_corp_name"
                        name="corp_name"
                        label={I18n.t("service.label_000110")}
                        floatingLabel
                      />
                      {this.renderFormItemError("corp_name")}
                    </div>
                    <div className="col-sm-12">
                      <Textfield
                        className="w100per"
                        id="enterprise_inquiry_email"
                        name="email"
                        label={I18n.t("service.label_000500")}
                        floatingLabel
                      />
                      {this.renderFormItemError("email")}
                    </div>
                    <div className="col-sm-12">
                      <Textfield
                        className="w100per"
                        id="enterprise_inquiry_tel"
                        name="tel"
                        label={I18n.t("service.label_000111")}
                        floatingLabel
                      />
                      {this.renderFormItemError("tel")}
                    </div>
                    <div className="col-sm-12">
                      <Textfield
                        className="w100per"
                        id="enterprise_inquiry_content"
                        name="content"
                        label={I18n.t("service.label_000112")}
                        rows={defaultRows}
                        floatingLabel
                      />
                      {this.renderFormItemError("content")}
                    </div>
                    <div className="col-sm-12 ta-c">
                      <input type="submit" name="commit" value={I18n.t("service.label_000113")} className="button-blue mt20 pt15 pb15 w300 sm-w100" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="site-main">
        <div className="enterprise__hero"><img src={SMRailsBridge.assetPath.enterpriseHero} alt="" className="enterprise__hero-img" /></div>
        <div className="page__odd">
          <div className="container">

            <div className="enterprise__box">
              <h1 className="enterprise__about-title">
                <span className="enterprise__about-title-supplement">参加者と一緒に創る！スペースマーケットの</span><br />
                シェアリング型イベントマーケティング
              </h1>
              <img src={SMRailsBridge.assetPath.enterpriseAbout} alt="" className="enterprise__about-img" />
              <p className="enterprise__about-text">
                シェアリング型イベントマーケティングは、<br className="sm-hide" />
                顧客主体型のイベントに商品やブランドを体験させる空間を創り出し<br className="sm-hide" />
                顧客の共感・行動変容をもたらすためのマーケティング概念です。
              </p>
              <p className="enterprise__about-text">
                顧客主体型のイベントでは参加者一人一人が「自らが主人公」。<br className="sm-hide" />
                自分が体験したこととして記憶により深く残り、共感や拡散が生まれやすくなります。<br className="sm-hide" />
              </p>
              <p className="enterprise__about-text">
                スペースマーケットでは、企業が顧客と商品やブランド価値をシェアする<br className="sm-hide" />
                「参加者と一緒に創る」マーケティングコミュニケーションの実現を支援します。
              </p>
            </div>

            <div className="enterprise__box">
              <h2 className="enterprise__box-title">マーケティングコミュニケーションは<br className="sm-hide" />「プッシュ型」から「シェア型」へ</h2>
              <img src={SMRailsBridge.assetPath.enterpriseRecent} alt="マーケティングコミュニケーションは「プッシュ型」から「シェア型」へ" className="enterprise__recent-img" />
              <p className="enterprise__recent-text">
                これまでの企業から顧客へのコミュニケーションは、<br className="sm-hide" />
                企業が商品訴求やブランドメッセージを一方的に発信する「プッシュ型」が一般的でした。<br className="sm-hide" />
                しかし、スマートフォンやSNSの一般化に伴い、テレビの平均視聴時間が減少するなどといったメディア接触の仕方も変化し、<br className="sm-hide" />
                従来の「プッシュ型」マーケティングコミュニケーションは機能しなくなってきました。
              </p>

              <img src={SMRailsBridge.assetPath.enterpriseAdvantageHero} alt="" className="enterprise__advantage-hero" />
              <p className="enterprise__advantage-connect">だからスペースマーケットでは・・・</p>
              <h2 className="enterprise__box-title">イベント参加者主体の空間を創り<br />記憶に深く残る「シェア型」の体験を届けます</h2>
              <p className="enterprise__recent-text">
                スペースマーケットが提供するシェアリング型イベントマーケティングは、<br className="sm-hide" />
                スペースマーケットを利用したイベント参加者に対して商品やブランドを活用した空間を提供します。<br className="sm-hide" />
                イベント参加者主体で設計した空間で、記憶に深く残るポジティブな体験を実現します。
              </p>
              <h3 className="enterprise__advantage-subtitle">スペースマーケットの強み</h3>
              <div className="row">
                <div className="col-md-4">
                  <img src={SMRailsBridge.assetPath.enterpriseAdvantage01} alt="幅広い利用者とスペースネットワーク" className="enterprise__advantage-img" />
                  <h4 className="enterprise__box-subtitle">幅広い利用者と<br />スペースネットワーク</h4>
                  <p className="enterprise__box-text">
                    スペースマーケットでは全国に1万を超えるスペースを掲載。さまざまなイベントの利用者を抱えています。
                  </p>
                </div>
                <div className="col-md-4">
                  <img src={SMRailsBridge.assetPath.enterpriseAdvantage02} alt="マーケティング効果を最大限に引き出す空間創り" className="enterprise__advantage-img" />
                  <h4 className="enterprise__box-subtitle">マーケティング効果を最大限に<br />引き出す空間創り</h4>
                  <p className="enterprise__box-text">
                    イベント参加者が共感したり楽しんだりできる空間創りのナレッジで、マーケティング効果を最大限に引き出します。
                  </p>
                </div>
                <div className="col-md-4">
                  <img src={SMRailsBridge.assetPath.enterpriseAdvantage03} alt="豊富な実績によるイベント運営・運用力" className="enterprise__advantage-img" />
                  <h4 className="enterprise__box-subtitle">豊富な実績による<br />イベント運営・運用力</h4>
                  <p className="enterprise__box-text">
                    場づくりやイベント企画で培った豊富な実績で、運営・運用の多くの要望にも対応可能です。
                  </p>
                </div>
              </div>
            </div>

            <div className="enterprise__box">
              <h3 className="enterprise__box-title">導入事例</h3>
              <div className="row">
                <div className="col-md-4">
                  <a href="https://beyond.spacemarket.com/experiences/perrier-party_scene/" target="_blank"><img src={SMRailsBridge.assetPath.enterpriseExNestle} alt="ネスレ日本株式会社様" className="enterprise__ex-img" /></a>
                  <h3 className="enterprise__box-subtitle">ネスレ日本株式会社様</h3>
                  <p className="enterprise__box-text">
                    ペリエブランドとコラボレーション。スペースマーケットの人気スペースに「場所・食事・アトラクション」を用意し、イベント参加者に非日常体験を提供しました。
                    <span className="enterprise__ex-link"><a href="https://beyond.spacemarket.com/experiences/perrier-party_scene/" target="_blank" className="link-hover-border"><i className="fa fa-angle-right mr5"></i>詳しく見る</a></span>
                  </p>
                </div>
                <div className="col-md-4">
                  <a href="https://beyond.spacemarket.com/experiences/sge_tribe_fes_2017/" target="_blank"><img src={SMRailsBridge.assetPath.enterpriseExCa} alt="株式会社サイバーエージェント様" className="enterprise__ex-img" /></a>
                  <h3 className="enterprise__box-subtitle">株式会社サイバーエージェント様</h3>
                  <p className="enterprise__box-text">
                    廃校となった奥多摩の小学校を会場とし、「夏フェス」に見立てた企業イベントを開催しました。
                    <span className="enterprise__ex-link"><a href="https://beyond.spacemarket.com/experiences/sge_tribe_fes_2017/" target="_blank" className="link-hover-border"><i className="fa fa-angle-right mr5"></i>詳しく見る</a></span>
                  </p>
                </div>
                <div className="col-md-4">
                  <a href="https://beyond.spacemarket.com/experiences/itoen_chakkathon/" target="_blank"><img src={SMRailsBridge.assetPath.enterpriseExItoen} alt="株式会社伊藤園様" className="enterprise__ex-img" /></a>
                  <h3 className="enterprise__box-subtitle">株式会社伊藤園様</h3>
                  <p className="enterprise__box-text">
                    お茶とハッカソンを組み合わせ、お茶をたしなみながら新しい文化を生み出す場を創り出しました。
                    <span className="enterprise__ex-link"><a href="https://beyond.spacemarket.com/experiences/itoen_chakkathon/" target="_blank" className="link-hover-border"><i className="fa fa-angle-right mr5"></i>詳しく見る</a></span>
                  </p>
                </div>
                <div className="col-md-12">
                  <a href="https://beyond.spacemarket.com/" className="button-blue mt20 pt15 pb15 w300 sm-w100 enterprise__ex-more" target="_blank">もっと見る</a>
                </div>
              </div>
            </div>

            <div className="enterprise__box">
              <h3 className="enterprise__box-title">その他取引先企業</h3>
              <p className="enterprise__recent-text">大企業からベンチャー・スタートアップまで幅広い取引実績がございます。</p>
              <ul className="static-appeal__list clearfix mb30">
                <li><img src={SMRailsBridge.assetPath.companyBase} alt="" /></li>
                <li><img src={SMRailsBridge.assetPath.companyKaizen} alt="" /></li>
                <li><img src={SMRailsBridge.assetPath.companyWantedly} alt="" /></li>
                <li><img src={SMRailsBridge.assetPath.enterpriseCompanyChiba} alt="" /></li>
                <li><img src={SMRailsBridge.assetPath.enterpriseCompanyCyberagent} alt="" /></li>
                <li><img src={SMRailsBridge.assetPath.enterpriseCompanyHamamatsu} alt="" /></li>
                <li><img src={SMRailsBridge.assetPath.enterpriseCompanyItoen} alt="" /></li>
                <li><img src={SMRailsBridge.assetPath.enterpriseCompanyMorinaga} alt="" /></li>
                <li><img src={SMRailsBridge.assetPath.enterpriseCompanyMynavi} alt="" /></li>
                <li><img src={SMRailsBridge.assetPath.enterpriseCompanyNestle} alt="" /></li>
                <li><img src={SMRailsBridge.assetPath.enterpriseCompanyOisix} alt="" /></li>
                <li><img src={SMRailsBridge.assetPath.enterpriseCompanyRecruit} alt="" /></li>
                <li><img src={SMRailsBridge.assetPath.enterpriseCompanySalesforce} alt="" /></li>
                <li><img src={SMRailsBridge.assetPath.enterpriseCompanySegagames} alt="" /></li>
                <li><img src={SMRailsBridge.assetPath.enterpriseCompanyShimabara} alt="" /></li>
              </ul>
            </div>

            <h3 className="enterprise__box-title">イベント実施までの流れ</h3>
            <div className="container row enterprise__flow-box">
              <div className="col-xs-6 col-md-3">
                <div className="enterprise__flow-step-1 enterprise__flow-step">
                  <p className="enterprise__flow-thumbnail"><img src={SMRailsBridge.assetPath.enterpriseFlow01} alt="ヒアリング" /></p>
                  <h3 className="enterprise__flow-step-title">1. ヒアリング</h3>
                  <p>希望するイベント形態、提供したい価値などについてヒアリングを行います。</p>
                </div>
              </div>
              <div className="col-xs-6 col-md-3">
                <div className="enterprise__flow-step-2 enterprise__flow-step">
                  <p className="enterprise__flow-thumbnail"><img src={SMRailsBridge.assetPath.enterpriseFlow02} alt="企画・提案" /></p>
                  <h3 className="enterprise__flow-step-title">2. 企画・提案</h3>
                  <p>ヒアリング内容をもとに貴社に合わせた独自のイベント企画を提案します。</p>
                </div>
              </div>
              <div className="col-xs-6 col-md-3">
                <div className="enterprise__flow-step-3 enterprise__flow-step">
                  <p className="enterprise__flow-thumbnail"><img src={SMRailsBridge.assetPath.enterpriseFlow03} alt="実施" /></p>
                  <h3 className="enterprise__flow-step-title">3. 実施</h3>
                  <p>企画したイベントを実施します。</p>
                </div>
              </div>
              <div className="col-xs-6 col-md-3">
                <div className="enterprise__flow-step-4 enterprise__flow-step">
                  <p className="enterprise__flow-thumbnail"><img src={SMRailsBridge.assetPath.enterpriseFlow04} alt="フィードバック" /></p>
                  <h3 className="enterprise__flow-step-title">4. フィードバック</h3>
                  <p>イベントの実施によってどのような効果があったかを振り返ります。</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page__even">
          {this.renderEnterpriseInquiryForm()}
        </div>
      </div>
    );
  }
}

export default SMEnterpriseView;



// WEBPACK FOOTER //
// ./app/javascript/components/enterprises/SMEnterpriseView.jsx